import {CLEAR_NUMBER_ANALYZE, FETCH_NUMBER_ANALYZE, LIST_NUMBER_ANALYZE} from "./types";


const init = {
    isLoading: false,
    data: null,
    filter: {}
};
export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_NUMBER_ANALYZE:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_NUMBER_ANALYZE:
            return {
                ...state,
                isLoading: false,
                data: payload.data
            };
        case CLEAR_NUMBER_ANALYZE:
            return {
                ...init
            };
        default:
            return state

    }
}
